import React, { useEffect, useState } from 'react'
import { Steps, Spin } from 'antd'
import { getSyncDetalle } from 'src/services/preciosService'

const LABELS = { sap: 'SAP', ia: 'Agente IA', impulsa: 'Impulsa', ecommerce: 'Ecommerce/Vtex' }

// estado tarea -> status del Step antd
const statusDe = (estado) => {
  if (estado === 'ok') return 'finish'
  if (estado === 'error') return 'error'
  if (estado === 'pendiente') return 'process'
  return 'wait'
}

const textoEstado = (t) => {
  if (t.estado === 'ok') return `Reflejado ${t.fecha_resuelto || ''}${t.resuelto_por ? ` · ${t.resuelto_por}` : ''}`
  if (t.estado === 'error') return 'Error / bloqueado'
  return 'Pendiente'
}

const TimelineDetalle = ({ material }) => {
  const [tareas, setTareas] = useState(null)

  useEffect(() => {
    let activo = true
    getSyncDetalle(material).then((res) => {
      if (activo && res && res.success) setTareas(res.data)
      else if (activo) setTareas([])
    })
    return () => {
      activo = false
    }
  }, [material])

  if (tareas === null) return <div style={{ padding: 16 }}><Spin size="small" /> Cargando línea de tiempo…</div>
  if (!tareas.length) return <div style={{ padding: 16, color: '#6b7684' }}>Sin tareas de sincronización para este material.</div>

  const apertura = tareas[0] ? tareas[0].fecha_apertura : ''
  const orden = ['sap', 'ia', 'impulsa', 'ecommerce']
  const map = {}
  tareas.forEach((t) => {
    map[t.sistema] = t
  })

  const items = [
    { title: 'Precio actualizado', status: 'finish', description: apertura || '—' },
    ...orden
      .filter((s) => map[s])
      .map((s) => ({
        title: LABELS[s],
        status: statusDe(map[s].estado),
        description: textoEstado(map[s]),
      })),
  ]

  return (
    <div style={{ padding: '16px 12px', background: '#fafbfc' }}>
      <Steps size="small" labelPlacement="vertical" items={items} />
    </div>
  )
}

export default TimelineDetalle
